import React, { useEffect, useState } from 'react'
import {
  Edit,
  required,
  SimpleForm,
  TextInput,
  useNotify,
  useRedirect,
  useTranslate,
  useEditController,
  NumberInput,
  useResourceContext,
} from 'react-admin'
import { Grid, Skeleton } from '@mui/material'
import { CardCommon } from 'src/components/uiElements'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { CardCrudBottomButtons } from 'src/components/uiElements/CRUD/CardCrudBottomButtons'
import { workUnitPaymentServices } from 'src/services/payment/workUnit/WorkUnit.service'
import { SelectInput } from 'src/components/uiElements/fields/SelectInput'

export const BankEdit = (props, { id }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const redirect = useRedirect()
  const resourceName = useResourceContext()
  const [workUnitList, setWorkUnitList] = useState([])
  const [loadingWorkUnitList, setLoadingWorkUnitList] = useState(false)

  const { record } = useEditController({ resource: resourceName, id })

  useEffect(() => {
    getWorkUnit()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getWorkUnit = async () => {
    try {
      setLoadingWorkUnitList(true)
      const allWorkUnit = await workUnitPaymentServices.getByAll()
      setWorkUnitList(allWorkUnit)
      setLoadingWorkUnitList(false)
    } catch (error) {
      setWorkUnitList([])
      setLoadingWorkUnitList(false)
    }
  }

  const onSuccess = () => {
    notify('ra.notification.updated_success_femenine', {
      type: 'success',
      messageArgs: { element: translate('ra.single_entity.bank') },
    })
    redirect('/bank')
  }

  const onError = () => {
    notify('ra.notification.updated_error_femenine', {
      type: 'error',
      messageArgs: { element: translate('ra.single_entity.bank') },
    })
  }

  return (
    <Edit {...props} mutationMode='pessimistic' mutationOptions={{ onSuccess, onError }} actions={null}>
      <CardCommon title={translate('ra.title.update_bank')}>
        <SimpleForm
          toolbar={
            <CardCrudBottomButtons
              btnSave={true}
              btnDelete={true}
              fieldsName={['name']}
              genderElement='femenine'
            />
          }
        >
          <Grid container spacing={3}>
            <EditInputsWrap label={translate('ra.field.id')}>
              <TextInput disabled source='id' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.name')} required>
              <TextInput source='name' label={false} fullWidth validate={[required()]} />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.code')}>
              <TextInput source='code' label={false} fullWidth />
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.work_unit')} required>
              {loadingWorkUnitList ? (
                <Skeleton variant='rectangular' width={'100%'} height={40} />
              ) : (
                <SelectInput
                  size='small'
                  optionsText={['long_name']}
                  fullWidth
                  label=''
                  source='work_unit_id'
                  defaultValue={record?.work_unit_id}
                  options={workUnitList}
                  validate={[required()]}
                />
              )}
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.account_number')}>
              <TextInput source='account_number' label={false} fullWidth />
            </EditInputsWrap>
          </Grid>
        </SimpleForm>
      </CardCommon>
    </Edit>
  )
}
